import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setAuthToken } from '../../../service/auth.utils';

const TokenRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      try {
        // Store the token in localStorage
        localStorage.setItem('accessToken', token);
        setAuthToken();

        // Navigate to dashboard
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Error processing token redirect:', error);
        navigate('/auth/login', { replace: true });
      }
    } else {
      // No token found, redirect to login
      navigate('/auth/login', { replace: true });
    }
  }, [searchParams, navigate]);

  // Show a loading message while processing
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      Processing login...
    </div>
  );
};

export default TokenRedirect;
